import { Record } from 'immutable';
import { merge } from 'lodash';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  desking: null,
  sendingDesking: false,
  pushingToCRM: false,
  creatingOffer: false,
  deletingOffer: false,
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

const addOffer = (desking, newDeskingOffer) => {
  const newDeskingOffers = [...desking.deskingOffers, newDeskingOffer];
  return { ...desking, deskingOffers: newDeskingOffers };
};

const updateOfferAfterSend = (desking, pencil) => {
  const newDeskingOffers = desking.deskingOffers.map(offer => ({
    ...offer,
    sentToSalespersonAt: offer.isSelectedOffer ? pencil.createdAt : null,
    changeLog: null,
  }));
  return { ...desking, deskingOffers: newDeskingOffers };
};

const updateOffer = (desking, updatedDeskingOffer) => {
  const newDeskingOffers = desking.deskingOffers.map(offer =>
    offer.id === updatedDeskingOffer.id ? updatedDeskingOffer : offer,
  );
  return { ...desking, deskingOffers: newDeskingOffers };
};

const deleteOffer = (desking, deletedDeskingOffer) => {
  const newDeskingOffers = desking.deskingOffers.filter(
    offer => offer.id !== deletedDeskingOffer.id,
  );
  return { ...desking, deskingOffers: newDeskingOffers };
};

function bulkUpdateOffers(desking, deskingOfferList) {
  return deskingOfferList.reduce(updateOffer, desking);
}

function mergePartialOffersToExisting(existingOffers, partialOffers) {
  if (!partialOffers.length) {
    return [];
  }
  const mergedOffers = [];
  for (const partialOffer of partialOffers) {
    const existingOffer = existingOffers.find(o => o.id === partialOffer.id);
    if (existingOffer) {
      mergedOffers.push(merge({}, existingOffer, partialOffer));
    }
  }
  return mergedOffers;
}

function bulkUpdatePartialOffers(desking, partialOffers) {
  const mergedOffers = mergePartialOffersToExisting(
    desking.deskingOffers,
    partialOffers,
  );
  return mergedOffers.reduce(updateOffer, desking);
}

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.DESKING_REQUEST:
    case types.DESKINGOFFER_BULK_UPDATE_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.DESKINGOFFER_CREATE_REQUEST:
    case types.DESKINGOFFER_CREATE_DEFAULT_REQUEST:
      return state.set('creatingOffer', true);
    case types.DESKINGOFFER_DELETE_REQUEST:
      return state.set('deletingOffer', true);
    case types.DESKINGOFFER_CRM_PUSH_REQUEST:
      return state
        .set('pushingToCRM', true)
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.DESKING_SUCCESS:
    case types.SET_DESKING:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('desking', payload);
    case types.SET_DESKINGOFFERS:
      return state.set(
        'desking',
        bulkUpdateOffers(state.get('desking'), payload),
      );
    case types.SET_PARTIALOFFERS:
      return state.set(
        'desking',
        bulkUpdatePartialOffers(state.get('desking'), payload),
      );
    case types.DESKING_SEND_TO_SALESPERSON_SUCCESS:
      return state
        .set('sendingDesking', false)
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('desking', updateOfferAfterSend(state.get('desking'), payload));
    case types.DESKINGOFFER_CREATE_SUCCESS:
      return state
        .set('creatingOffer', false)
        .set('desking', addOffer(state.get('desking'), payload));
    case types.DESKINGOFFER_BULK_UPDATE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.DESKINGOFFER_DELETE_SUCCESS:
      return state
        .set('deletingOffer', false)
        .set('desking', deleteOffer(state.get('desking'), payload));
    case types.DESKINGOFFER_CRM_PUSH_SUCCESS:
      return state
        .set('pushingToCRM', false)
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.DESKINGOFFER_BULK_UPDATE_FAILURE:
    case types.DESKING_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.DESKINGOFFER_CREATE_FAILURE:
      return state.set('creatingOffer', false);
    case types.DESKINGOFFER_DELETE_FAILURE:
      return state.set('deletingOffer', false);
    case types.DESKINGOFFER_CRM_PUSH_FAILURE:
      return state
        .set('pushingToCRM', false)
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.DESKING_SEND_TO_SALESPERSON_REQUEST:
      return state
        .set('sendingDesking', true)
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.DESKING_SEND_TO_SALESPERSON_FAILURE:
      return state
        .set('sendingDesking', false)
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    default:
      return state;
  }
};
